
import Vue from "vue";
import { getDeviceUuid } from "../../services/deviceUuid";

export default Vue.extend({
  beforeMount() {
    // @ts-ignore
    const parser = new UAParser();
    const result = parser.getResult();

    this.so = result.os.name;

    this.navegador = result.browser.name;

    this.soIcon = this.so.toLowerCase();
    if (this.soIcon == "ios") {
      this.soIcon = "apple";
    }

    this.formaDispositivo =
      result.device.type[0].toUpperCase() + result.device.type.slice(1);

    if (this.formaDispositivo == "Mobile") {
      this.formaDispositivo = "Móvil";
    }
  },

  data() {
    return {
      so: "",
      formaDispositivo: "Ordenador",
      descripcion: "",
      navegador: "",
      soIcon: ""
    };
  },
  methods: {
    async confirmRegistrarDispositivo() {
      this.$dialog.confirm({
        title: "Registrar Dispositivo",
        message: "¿Seguro que quieres registrar este dispositivo?",
        confirmText: "Confirmar",
        cancelText: "Cancelar",
        type: "is-success",
        hasIcon: true,
        onConfirm: async () => await this.registrarDispositivo()
      });
    },
    registrarDispositivo() {
      const uuid = getDeviceUuid();
      if (uuid === false) {
        this.$toast.open({
          message: "Error, no se pudo crear el identificador",
          type: "is-danger",
          position: "is-bottom"
        });
        return null;
      }
      const datos = {
        identificacion: uuid,
        descripcion: this.descripcion,
        formaDispositivo: this.formaDispositivo,
        navegador: this.navegador,
        sistema: this.so
      };
      this.$http
        .post("Dispositivo", datos, {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`
          }
        })
        .then(res => {
          this.$toast.open({
            message: "Dispositivo registrado correctamente",
            type: "is-success",
            position: "is-bottom"
          });
          this.descripcion = "";
        })
        .catch(err => {
          this.$toast.open({
            message: err.response.data || "Error al registrar el dispositivo",
            type: "is-danger",
            position: "is-bottom"
          });
        });
    }
  }
});
